import { render, staticRenderFns } from "./StepLogistics.vue?vue&type=template&id=7aabac20&scoped=true"
import script from "./StepLogistics.vue?vue&type=script&lang=js"
export * from "./StepLogistics.vue?vue&type=script&lang=js"
import style0 from "./StepLogistics.vue?vue&type=style&index=0&id=7aabac20&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7aabac20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-平台矩阵/platform-miniprogram-cms/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7aabac20')) {
      api.createRecord('7aabac20', component.options)
    } else {
      api.reload('7aabac20', component.options)
    }
    module.hot.accept("./StepLogistics.vue?vue&type=template&id=7aabac20&scoped=true", function () {
      api.rerender('7aabac20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/orderManagement/components/StepLogistics.vue"
export default component.exports